export default "__VITE_ASSET__CW$BduDn__"